(function(app) {

    app.provider("marketingTrackerAuthService",
    [
        function() {
            this.$get = [
                "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                    return {
                        getAccessToken: getAccessToken,
                        setAccessToken: setAccessToken,
                        logout: logout
                    };

                    function setAccessToken(token) {
                        localStorage.setItem("Auth.MarketingTrackerAccessToken", token);
                    }

                    function getAccessToken() {
                        return localStorage.getItem("Auth.MarketingTrackerAccessToken");
                    }

                    function removeAccessToken() {
                        localStorage.removeItem("Auth.MarketingTrackerAccessToken");
                    }

                    function logout() {
                        removeAccessToken();
                    }
                }
            ];
        }
    ]);

    app.run([
        "marketingTrackerApiGateway", function(api) {
            api.addInterceptor([
                "marketingTrackerAuthService", function(marketingTrackerAuthService) {
                    return {
                        request: function(config) {
                            var token = marketingTrackerAuthService.getAccessToken();
                            if (token)
                                config.headers.Authorization = "Bearer " + token;
                            return config;
                        }
                    };
                }
            ]);
        }
    ]);
})(window.app); //jshint ignore:line